<template>
  <div>
    Some Content Here
  </div>
</template>

<script>

  // global variables
  import Vuex from 'vuex';
  import { mapState } from 'vuex'
  import VuexFire from 'vuexfire';
  import firebase from 'firebase';
  import router from "../router"
  // end global variables

  // firebase initialisation
  var db = firebase.database();
  // end firebase initialisation

  // helper functions
  // end helper functions

  export default {
    name: "dynamic",
    computed: {
      ...mapState({
        // map e.g. this.authData to store.state.authData
        authData: 'authData',
        dynamic: 'dynamic'
      })
    },
    data () {
      return {
        //queryString: queryString,
      }
    },
    firebase: {
      //users: db.ref('users'), // user database
      dynamic: db.ref('dynamic') // dynamic content database
    },
    methods: {
    },
    components: {
    }
  }
</script>



/** WEBPACK FOOTER **
 ** dynamic.vue?6bd225c0
 **/